import React from "react"

import SectionHeading from "components/section-heading"
import {
  Container,
  Content,
  JumboWrapper,
  Inner,
  DesktopWrapper,
  MobileWrapper,
  ScrollLabel,
  ScrollContainer,
  ScrollableGrid,
  CustomGrid,
  ButtonContainer,
  LeftContainer,
  TextLinkCardsContainer,
} from "./styles"

const TileGrid = ({
  title,
  subtitle,
  logo,
  logoAspectRatio,
  jumboSlotCard,
  largeSlotCard,
  children,
  elRef,
  dataId,
  hideOnPageLoad,
  buttonElement,
  useMonoline,
  useHeadingLine,
  largeOuterPadding,
  largeColMargin,
  leftWidth,
  useHorizontalScrollOnMobile,
  renderWithoutImages,
  ...props
}) => {
  const elements = React.Children.toArray(children)
  const numItems = (jumboSlotCard ? 1 : 0) + (largeSlotCard ? 1 : 0) + elements.length

  if (![3, 5, 6, 7, 8].includes(numItems)) {
    console.error("Tile grid must have 3, 5, 6 or 8 items")
    return null
  }

  const numColumns = numItems === 3 ? 1 : 2

  const renderGrid = () => (
    <>
      <CustomGrid
        rowMargin="0.6rem !important"
        colMargin={largeColMargin ? "2rem" : "0.6rem"}
        numColumns={{
          default: numColumns,
          desktopL: numColumns,
          desktop: 2,
          tablet: 2,
          mobile: 1,
        }}
      >
        {elements.slice(0, numItems === 8 || numItems === 3 ? 2 : 4)}
      </CustomGrid>

      {numItems === 8 && (
        <div>
          <CustomGrid
            rowMargin="0.6rem !important"
            colMargin={largeColMargin ? "2rem" : "0.6rem"}
            numColumns={{
              default: 5,
              desktopL: 5,
              desktop: 3,
              tablet: 2,
              mobile: 1,
            }}
          >
            {elements.slice(2)}
          </CustomGrid>
        </div>
      )}
    </>
  )

  return (
    <Container
      hideOnPageLoad={hideOnPageLoad}
      data-exp-id={dataId}
      ref={elRef}
      largeOuterPadding={largeOuterPadding}
      {...props}
    >
      <SectionHeading
        title={title}
        subtitle={subtitle}
        logo={logo}
        logoAspectRatio={logoAspectRatio}
        mobileNoBorder
        useMonoline={useMonoline}
        useLine={useHeadingLine}
      />
      <Content hasMindbodygreenTitle={title === "Mindbodygreen" && useMonoline}>
        {jumboSlotCard && <JumboWrapper>{jumboSlotCard}</JumboWrapper>}
        <Inner
          numItems={numItems}
          hasJumbo={!!jumboSlotCard}
          largeColMargin={largeColMargin}
          leftWidth={leftWidth}
          useHorizontalScrollOnMobile={useHorizontalScrollOnMobile}
        >
          {leftTileGridContainer(renderWithoutImages, largeSlotCard)}

          <DesktopWrapper>{renderGrid()}</DesktopWrapper>
          <MobileWrapper>
            {useHorizontalScrollOnMobile ? (
              <>
                <ScrollLabel>latest articles</ScrollLabel>
                <ScrollContainer>
                  <ScrollableGrid>{elements}</ScrollableGrid>
                </ScrollContainer>
              </>
            ) : (
              renderGrid()
            )}
          </MobileWrapper>
        </Inner>
        {buttonElement && <ButtonContainer bottom>{buttonElement}</ButtonContainer>}
      </Content>
    </Container>
  )
}

const leftTileGridContainer = (renderWithoutImage, largeSlotCard) =>
  renderWithoutImage
    ? (
        <LeftContainer>
          <div>{largeSlotCard}</div>
          <TextLinkCardsContainer>{renderWithoutImage}</TextLinkCardsContainer>
        </LeftContainer>
      ) || <div />
    : (
        <LeftContainer>
          <div>{largeSlotCard}</div>
        </LeftContainer>
      ) || <div />

export default TileGrid
